<template>
  <div style="text-align: center;font-size: 0;">
    <img v-if="current == 1" src="@/assets/image/f-step1.png" />
    <img v-else-if="current == 2" src="@/assets/image/f-step2.png" />
    <img v-else-if="current == 3" src="@/assets/image/f-step3.png" />
    <img v-else-if="current == 4" src="@/assets/image/f-step4.png" />
  </div>
</template>

<script>
export default {
  name: "navStepList3",
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
};
</script>
